import {AddPublicInformationModalProps} from "./types";
import {useMemo} from "react";
import {Modal, Spin} from "antd";
import PublicInformationForm from "./form";

const AddPublicInformationModal = (props: AddPublicInformationModalProps) => {
  const {publicInfoController} = props
  const {selectedPublicInfoItem, isModalOpen, form, toggleModal, isLoading} = publicInfoController

  const title = useMemo(() => {
    return selectedPublicInfoItem ? "Редагувати публічну інформацію" : "Додати публічну інформацію"
  }, [selectedPublicInfoItem])


  return <Modal width={700} style={{top: 20}} title={title} open={isModalOpen} onOk={() => {
    form.submit()
  }}
                onCancel={toggleModal}
                cancelButtonProps={{title: "Закрити"}} okButtonProps={{children: "Зберегти"}}>
    <Spin spinning={isLoading}>
      <PublicInformationForm publicInfoController={publicInfoController}/>
    </Spin>
  </Modal>

}
export default AddPublicInformationModal